module.exports = __webpack_public_path__ + "static/media/logout.3a5efe9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logout.svg
// module id = 1132
// module chunks = 1